import React from "react";

import { cx } from "~/tools/class-variance";

import styles from "./_table.module.css";
import { TableCell } from "./cell";

export type TableHeadCellProps = React.ComponentPropsWithoutRef<typeof TableCell>;

export const TableHeadCell = React.forwardRef<React.ComponentRef<typeof TableCell>, TableHeadCellProps>(
	({ className, ...props }, ref) => (
		<TableCell {...props} className={cx(styles.headCell, className)} ref={ref} role="columnheader" />
	),
);
